'use client';

import { Text, Tooltip } from '@terra/ui-design-system';
import { HStack } from '@terra/ui-styled-system';
import { ArrowLeftRightIcon, File01Icon } from '@terra/ui-icons';

const TOOLTIP_HAR = 'HAR Entries';
const TOOLTIP_PAGES = 'Pages';

function formatCompact(n: number): string {
  if (n >= 999950) {
    return `${(n / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  }

  if (n >= 1000) {
    return `${(n / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  }

  return String(n);
}

interface CrawlerInlineStatsProps {
  harTotal: number;
  pagesTotal: number;
  textSize?: 'xs' | '2xs';
}

export function CrawlerInlineStats({
  harTotal,
  pagesTotal,
  textSize = 'xs',
}: CrawlerInlineStatsProps) {
  return (
    <HStack
      gap="2"
      alignItems="center"
      color="fg.muted"
      flexShrink={0}
      whiteSpace="nowrap"
    >
      <Tooltip
        positioning={{ placement: 'top' }}
        title={`${TOOLTIP_HAR}: ${harTotal.toLocaleString()}`}
      >
        <HStack gap="1" alignItems="center" cursor="default">
          <ArrowLeftRightIcon size={12} />
          <Text fontSize={textSize} fontWeight="medium">
            {formatCompact(harTotal)}
          </Text>
        </HStack>
      </Tooltip>

      <Tooltip
        positioning={{ placement: 'top' }}
        title={`${TOOLTIP_PAGES}: ${pagesTotal.toLocaleString()}`}
      >
        <HStack gap="1" alignItems="center" cursor="default">
          <File01Icon size={12} />
          <Text fontSize={textSize} fontWeight="medium">
            {formatCompact(pagesTotal)}
          </Text>
        </HStack>
      </Tooltip>
    </HStack>
  );
}
